import {AxiosChatInstance, AxiosInstance, AxiosPublicationsInstance} from "../api/AxiosInstance";

const appendFormDataValue = (formData, key, value, { optional = false } = {}) => {
  const isEmpty = value === undefined || value === null || value === "";
  if (optional && isEmpty) return;

  formData.append(key, isEmpty ? "" : value);
};

const isBinaryFile = (value) => value instanceof File || value instanceof Blob;

const buildRegisterInfoFormData = (userinfo) => {
  const formData = new FormData();
  const imageFile = userinfo?.Fotografia || userinfo?.fotografia;

  appendFormDataValue(formData, "Nacionalidad", userinfo?.nacionalidad);
  appendFormDataValue(formData, "Edad", userinfo?.edad);
  appendFormDataValue(formData, "Nombre", userinfo?.nombre);
  if (imageFile) {
    if (!isBinaryFile(imageFile)) {
      throw new Error("Fotografia must be a File or Blob.");
    }
    formData.append("Fotografia", imageFile, imageFile.name);
  }
  appendFormDataValue(formData, "NickName", userinfo?.nickName);
  appendFormDataValue(formData, "Genero", userinfo?.genero);
  appendFormDataValue(formData, "IdUsuario", userinfo?.idUsuario);
  appendFormDataValue(formData, "Ocupacion", userinfo?.ocupacion, { optional: true });
  appendFormDataValue(formData, "Apellido", userinfo?.apellido);

  return formData;
};

export const registerInfo = async (userinfo) => {
  try {
    const response = await AxiosInstance.post(
      "/api/ob/usr/conf",
      buildRegisterInfoFormData(userinfo),
    )
    return response.data
  } catch (error) {
    throw error.response?.data || "Save user info failed"
  }
}

export const registerPhoto = async (photoInfo) => {
  try {
    const response = await AxiosInstance.post("/api/ob/usr/img/prof", photoInfo)
    return response.data
  } catch (error) {
    throw error.response?.data || "Save user Profile Picture failed"
  }
}

export const getInfoPassport = async (userId) => {
  try {
    const response = await AxiosInstance.get(`/api/passport?id=${userId}`)
    return response.data
  } catch (error) {
    throw error.response?.data || "Failed get passport info"
  }
}

// Refactor this function only gets user posts not user personal data
export const getUserInfo = async (userId) => {
  try {
    const response = await AxiosInstance.get(`/api/ob/usr/info?idUsuario=${userId}`)
    return response.data
  } catch (error) {
    throw error.response?.data || "Save user Profile Picture failed"
  }
}

//  export const getUserInfo = async (userId , jwt) => {
//    try {
//      const response = await AxiosInstance.get(`/api/ob/usr/info?idUsuario=${userId}`,{
//         headers: { Authorization: `Bearer ${jwt}` },
//      })
//      return response.data
//    } catch (error) {
//      throw error.response?.data || "Failed get user info"
//    }
//  }

export const getUserPhoto = async (userId) => {
  try {
    const idUsuario =
      userId?.IdUsuario ??
      userId?.idUsuario ??
      userId?.id ??
      userId;
    const response = await AxiosInstance.get(`/api/ob/usr/info?idUsuario=${idUsuario}`)
    const userInfo = response.data?.data ?? response.data ?? {}
    const fotoPerfilUrl =
      userInfo?.fotoPerfilUrl ??
      userInfo?.FotoPerfilUrl ??
      userInfo?.profilePic ??
      userInfo?.imagenBase64 ??
      userInfo?.fotoPerfilBase64 ??
      null;

    return {
      ...userInfo,
      content: fotoPerfilUrl,
    }
  } catch (error) {
    throw error.response?.data || "Get user Profile Picture failed"
  }
}

export const updateUserPhoto = async (userId) => {
  try {
    const response = await AxiosInstance.update("/api/ob/usr/img/patch", userId)
    return response.data
  } catch (err) {
    throw err.response?.data || "Update user Profile failed"
    
  }
}

export const updateUserInfo = async (userData) => {
  try {
    const response = await AxiosInstance.patch("/api/ob/usr/info", userData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    return response.data
  } catch (error) {
    throw error.response?.data || "Failed update user data"
  }
}

export const getOccupationsCatalog = async () => {
  try {
    const response = await AxiosInstance.get("/api/catalogo/profesiones")
    return response.data
  } catch (error) {
    throw error.response?.data || "Failed get occupations catalog"
  }
}

export const getUserFollowers = async (userId) => {
  try {
    const response = await AxiosPublicationsInstance.get(`/api/lista/seguidores?idUsuario=${userId}`)
    return response.data
  } catch (error) {
    throw error?.response || "Failed get user followers"
  }
}

export const getUserPrivacySettings = async (userId) => {
  try {
    const response = await AxiosPublicationsInstance.get(`/api/priv/etiquetado?idUsuario=${userId}`)
    return response.data
  } catch (error) {
    throw error?.response || "Failed get user privacy settings"
  }
}

export const getUserPrivacyConfiguration = async (userId) => {
  try {
    const response = await AxiosPublicationsInstance.get(`/api/obtener/configuracion-privacidad?idUsuario=${userId}`)
    return response.data
  } catch (error) {
    throw error?.response || "Failed get user privacy configuration"
  }
}

export const blockUser = async (req) => {
  try {
    const response = await AxiosPublicationsInstance.patch("/api/actualizar/configuracion-bloqueos", req)
    return response.data
  } catch (error) {
    throw error?.response || "Failed blocking user"
  }
}

export const followUser = async(req) => {
  try {
    const response = await AxiosPublicationsInstance.post("/api/user/seguir", req)
    return response.data
  } catch (error) {
    throw error?.response || "Failed following user"
  }
}

export const unFollowUser = async(req) => {
  try {
    const response = await AxiosPublicationsInstance.post("/api/user/dejarseguir", req)
    return response.data
  } catch (error) {
    throw error?.response || "Failed unfollowing user"
  }
}

export const updatePrivacySettings = async (req) => {
  try {
    const response = await AxiosPublicationsInstance.patch("/api/actualizar/configuracion-privacidad", req)
    return response.data
  } catch (error) {
    throw error?.response || "Failed update privacy settings"
  }
}

export const postEditPublication = async(req) => {
  try {
    const formData = new FormData()

    const imageIds = Array.isArray(req?.imagenes) ? req.imagenes : []
    const mentionedUsers = Array.isArray(req?.usuariosArrobados)
      ? req.usuariosArrobados
      : []

    appendFormDataValue(formData, "IdUsuario", req?.idUsuario)
    appendFormDataValue(formData, "IdPublicacion", req?.idPublicacion)
    appendFormDataValue(formData, "Comentario", req?.comentario)
    appendFormDataValue(formData, "Ubicacion", req?.ubicacion, { optional: true })
    appendFormDataValue(formData, "Modificado", req?.modificado)
    appendFormDataValue(formData, "Alcance", req?.alcance)
    appendFormDataValue(formData, "Visible", req?.visible)

    imageIds.forEach((imageId) => appendFormDataValue(formData, "Imagenes", imageId))
    mentionedUsers.forEach((userId) =>
      appendFormDataValue(formData, "UsuariosArrobados", userId),
    )

    const response = await AxiosPublicationsInstance.post(
      "/api/editar/publicacion/multipart",
      formData,
    )
    return response.data
  } catch (error) {
    throw error?.response || "Failed edit publication"
  }
}

// Eliminar cuenta
export const deleteAccount = async (data) => {
  try {
    const response = await AxiosInstance.post(`/api/eliminar/cuenta`, data)
    return response.data
  } catch (error) {
    throw error?.response || "Failed delete account"
  }
}

// Obtener catálogo de sellos
export const getStampCatalog = async () => {
  try {
    const response = await AxiosInstance.get(`/api/usr/catalogo/sellos`)
    return response.data
  } catch (error) {
    throw error?.response || "Failed get stamp catalog"
  }
}

// Obtener sellos de usuario
export const getUserStamps = async (idUsuario) => {
  try {
    const response = await AxiosInstance.get(`/api/usr/sellos?IdUsuario=${idUsuario}`)
    return response
  } catch (error) {
    throw error?.response || "Failed get stamp catalog"
  }
}

// Generar sello
export const postGenerateStamp = async (idSello) => {
  try {
    const response = await AxiosInstance.post(`/api/sellos/generar/sello`, idSello)
    return response.data
  } catch (error) {
    throw error?.response || "Failed generate stamp"
  }
}

// Obtener sello
export const getStampUserRelationship = async (data) => {
  try {
    const response = await AxiosInstance.post(`/api/usr/sello`, data)
    return response
  } catch (error) {
    throw error?.response || "Failed get stamp user relationship"
  }
}

// Geolocalización
export const getUserGeolocation = async (payload) => {
  try {
    const response = await AxiosChatInstance.post(`/api/insertar/geolocalizacion`, payload)
    return response
  } catch (error) {
    throw error?.response || "Failed get user geolocation"
  }
}

// Obtener proceso del usuario
export const getProcessUser = async (idSolicitud) => {
  try {
    const response = await AxiosInstance.get(`/api/usuario-verificado/obtener/formulario?IdSolicitud=${idSolicitud}`)
    return response
  } catch (error) {
    throw error?.response || "Failed get process user"
  }
}

// Obtener el estatus donde se quedo
export const getStatusUser = async (idUsuario) => {
  try {
    const response = await AxiosInstance.get(`/api/obtener/estatus-usuario?idUsuario=${idUsuario}`)
    return response
  } catch (error) {
    throw error?.response || "Failed get process user"
  }
}
